/**
 * Background attachment fixed fix
 *
 * background-attachment:fixed doesn't work
 * on iOS, so we're doing our best to detect such
 * browsers and defaulting to background-attachment:scroll.
 */
document.querySelectorAll('.has-parallax')?.forEach((el) => {
	const styles = getComputedStyle(el);
	if (styles.getPropertyValue('background-attachment') === 'fixed') {
		const iOSMaybe =
			['iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
			(navigator.userAgent.includes('Mac') && 'ontouchend' in document);
		if (iOSMaybe) {
			el.style.setProperty('background-attachment', 'scroll');
		}
	}
});
